<template>
  <section>
    <div class="view">
      <img src="../assets/wall01.jpg" class="img-fluid" alt="smaple image" width="100%" style="height: 500px">
      <div class="mask" style="color: white">
        <div class="container h-100">
          <div class="row justify-content-center h-100">
            <div class="col center ">
              <h1 class="text-center mb-4 h1-responsive">La manera más sencilla <br> de optimizar tu negocio.</h1>
              <h2 class="text-center mb-5 h2-responsive"> Soluciones a tu medida a un solo click</h2>
              <div class="row justify-content-center">
                <div class="col-lg-4 col-sm-4 ">
                  <a class=" btn  text-capitalize z-depth-0 px-1 py-1" style="color: white !important; background-color: #00A492 !important;" href="#soluciones">
                    <h3 class="text-truncate ml-auto mr-auto my-2">Conócelas</h3>
                  </a>
                </div>
                <div class="col-lg-1 col-sm-1">

                </div>
                <div class="col-lg-4 col-sm-4">
                  <a class=" btn  text-capitalize z-depth-0 px-1 py-1" style="color: white !important; border: solid #00A492 2px !important; background-color: rgba(0,0,0,0) !important;" @click="to('Landing')" href="#comoSeLogra">
                    <h3 class="text-truncate ml-auto mr-auto my-2">Aprender más</h3>
                  </a>
                </div>

              </div>

            </div>
          </div>


        </div>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>
  .center {
    margin-top: auto;
    margin-bottom: auto;
  }
  .btn{
    background-color: white;
    border-radius:25px!important;
    width:100%!important;
  }

</style>
